import { getUsersHandles } from '../../reduxes/slices/credentials/selectors'
import { useSelectorDelegateStore } from '../../reduxes/stores/root_store/hooks'
import { useFindAppRouteMatch } from './use_find_app_route_match'
import {useCallback} from "react";

export const useIsAppRoute = () => {
  const findAppRouteMatch = useFindAppRouteMatch()
  const handles = useSelectorDelegateStore(getUsersHandles)

  return useCallback((url: string) => {
    try {
      const { hostname, pathname } = new URL(url)
      if (hostname !== window.location.hostname) {
        return false
      }

      const match = findAppRouteMatch(pathname)
      return !!match && handles.includes(match.params.current_handle)
    } catch {
      return false
    }
  }, [findAppRouteMatch, handles])
}
